import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import { formatDate, getUniqNewsUrl, getLimitedDetailTextMax, CONSTRAINED_DETAIL_LENGTH_SMALL, CONSTRAINED_DETAIL_LENGTH_LARGE } from "./common/BaseUtil"
import '../App.css';
//icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';

export function NewsCard(props) {
    const [maxLength, setMaxLength] = useState(50);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 1300) {
                setMaxLength(CONSTRAINED_DETAIL_LENGTH_SMALL);
            } else {
                setMaxLength(CONSTRAINED_DETAIL_LENGTH_LARGE);
            }
        };

        handleResize(); // 초기 실행
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    let navigate = useNavigate();
    function clickSubmit() {
        let objectId = props.object.id.toString()
        let slug = props.object.slug
        let url = "/news/" + objectId + "/" + slug
        navigate(url);
    }

    return (
        <article class="card" itemScope itemType="http://schema.org/NewsArticle" key={props.index} className="card-height" style={{ marginTop: '15px', marginBottom: '15px' }} onClick={clickSubmit}>
            <div class="card-body d-flex">
                <div class="image-container" style={{ marginRight: '15px' }}>
                    <img class="float-start"
                        src={getUniqNewsUrl(props.object.uniqFileName, props.object.fileFormat)}
                        className="responsive-img"
                        style={{ borderRadius: "2%", boxShadow: "0 2px 8px rgba(0,0,0,0.3)" }}
                        alt={`독일뉴스 - ${props.object.newsTitle}`}
                        itemProp="image"
                        loading="lazy"
                    />
                </div>
                <div class="d-flex flex-column w-100" className="card-text-column">
                    <h2 class="card-title" className="card-list-main-title"
                        style={{
                            fontFamily: 'Nanum Gothic', fontWeight: 'bold', display: 'inline-block', fontSize: '1.125rem',
                            transition: 'color 0.3s ease, transform 0.3s ease', cursor: 'pointer'
                        }}
                        onMouseEnter={e => {
                            e.currentTarget.style.transform = 'scale(1.01)'; // 호버 시 확대
                        }}
                        onMouseLeave={e => {
                            e.currentTarget.style.transform = 'scale(1)';  // 원래 크기로 복원
                        }}
                        itemProp="headline"
                    >
                        {props.object.newsTitle}
                    </h2>
                    <p class="card-text" itemProp="description" className="detail-text">{getLimitedDetailTextMax(props.object.newsContent.replace(/(<([^>]+)>)/ig, '').replace(/&nbsp;/g, ' '), maxLength)}</p>
                    <p class="card-text mt-auto" style={{ fontSize: '13px' }}><FontAwesomeIcon icon={faClock} /><time dateTime={props.object.updateAt} itemProp="datePublished"> {formatDate(props.object.updateAt)}</time></p>
                </div>
            </div>
        </article>
    );
}